<template>
  <div style="height:100%">
    <top-header></top-header>
    <left-nav-menu class="nav" :title="title" :links="links" :cururl="curUrl"></left-nav-menu>
    <div class="main clearfix">
      <router-view :config="$route.config"></router-view>
    </div>
    <div class="loading" v-show="showLoading"><img src="@/assets/imgs/loading.gif"></div>
  </div>
</template>

<script>
  import TopHeader from './header.vue'
  import LeftNavMenu from './nav.vue'
  export default {
    components:{TopHeader,LeftNavMenu},
    name:"ContentContainer",
    data () {
      return {
        links:[],
        showLoading:false
      }
    },
    computed:{
      mainUrl () {
        return (/^(\/\w+\/\w+)(?=\/|$)/.exec(this.$route.path) || [])[0]
      },
      subUrl () {
        return (/^(\/\w+\/\w+)(?=\/|$)/.exec(this.$route.path) || [])[1]
      },
      curUrl () {
        return String(this.$route.path).split('/').splice(2,1)[0]
      },
      title () {
        switch (this.mainUrl) {
          case '/ams/admin':
            return this.$t('components.container.authority_management')
          case '/ims/barrage':
            return this.$t('components.container.barrage_management')
          case '/ims/user':
            return this.$t('components.container.user_management')
          case '/ims/vip':
            return this.$t('components.container.member_management')
          case '/ims/gold':
            return this.$t('components.container.gold_management')
          case '/ims/product':
            return this.$t('components.container.commodity_management')
          case '/ims/admin':
            return this.$t('components.container.authority_management')
          case '/ims/log':
            return this.$t('components.container.log_management')
          case '/ims/feedback':
            return this.$t('components.container.feedback')
          case '/mms/media':
            return this.$t('components.container.dibble_seeding_media_management')
          case '/mms/stream':
            return this.$t('components.container.live_media_management')
          case '/mms/config':
            return this.$t('components.container.config_management')
          case '/cms/ad':
            return this.$t('components.container.ad_management')
          case '/cms/cdn':
            return this.$t('components.container.cdn_management')
          case '/cms/content':
            return this.$t('components.container.operations_management')
          case '/cms/system':
            return this.$t('components.container.system_settings')
          case '/chat-query':
            return this.$t('components.container.chat_query')
          case '/monitor':
            return this.$t('components.container.monitor_management')
          default:
            return ''
        }
      }
    },
    watch:{
      'mainUrl': function () {
        this.getLinks()
      }
    },
    methods:{
      getLinks () {
        return this.$http.get('/ams/admin/page?url='+this.mainUrl).then(res => {
          this.links = (res.data.data || []).filter(v=>v.url!='');
          this.$route.meta.rights = (res.data.data || []).filter(v=>v.right!='');
          if(this.$route.params.app_id) {
            this.links.map(v => {
              var subUrl = (/^(\/\w+\/\w+)(\/\w.+)(?=|$)/.exec(v.url) || [])[2];
              v.url = this.mainUrl + "/app/" + this.$route.params.app_id + subUrl;
            })
          }
        }).then(()=>{
          if (this.$route.path === this.mainUrl+"/app/"+this.$route.params.app_id) {
            this.$router.replace(this.links[0].url)
          } else  if (this.$route.path === this.mainUrl) {
            this.$router.replace(this.links[0].url)
          }
        })
      }
    },
    mounted () {
//      this.getLinks()
      var _this = this;
      global.bus.$on("showLoading",function (showCount) {
        if(showCount==0) {
          _this.showLoading = false;
        } else {
          _this.showLoading = true;
        }
      })
    }
  }
</script>

<style lang="less" scoped>
  @import "@/assets/css/varible.less";
  .loading{
    z-index: 999;
    position: absolute;
    top:30%;
    left: 50%;
  }
  .main{
    background: @gray;
    position: absolute;
    top:@header-height;
    left:@left-nav-width;
    bottom:0;
    right: 0;
    overflow-y: auto
  }
  .nav{
    position: absolute;
    left: 0;
    top:@header-height;
    bottom:0;
    overflow: hidden;
    width: @left-nav-width;
    color: #fff;
    background: #0b3c5d;
    i{
      margin-right: 10px;
      font-size: 18px;
    }
  }
</style>
